<template>
  <v-layout style="flex-direction:column">    
    <v-tabs class="mx-2 mt-2 sub-menu" style="flex:0 0 auto;"      
      slider-color="primary">                  
      <h2 class="pa-2">{{fleet.FLE_LIBELLE}} : </h2>   
      <v-tab exact ripple :to="{name:'EditAdminFleet'}">      
        Fiche Fleet
      </v-tab>  
      <v-tab exact ripple :to="{name:'FormAdminFleet'}">
        Infos générales
      </v-tab>      
      <v-tab ripple :to="{name:'ConfigAdminFleet'}">
        Config
      </v-tab>
    </v-tabs>    
    <router-view class="mt-0" />    
  </v-layout>
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'


  @Component({
    name: 'AdminAdminFleetMenu'
  })
  export default class AdminAdminFleetMenu extends Vue {  
    get fleet() {
      return this.$store.myGetters.originalAdmAdminFleet
    }
  }
</script>

<style scope>

  .sub-menu .v-tabs__item--active{
    background-color:transparent;
  } 

</style>
